/** @file Card: a clickable tile (project, template) that also opens a context menu on right-click. */
import type { MouseEvent, ReactElement, ReactNode } from 'react';

/** Title, subtitle, extra body, the open action and the right-click handler (gets viewport coordinates). */
export type CardProps = {
  title: string; subtitle?: string; children?: ReactNode; onOpen?: () => void;
  onMenu?: (x: number, y: number) => void;
};

/** A `<button>` tile; right-click calls `onMenu` with the pointer position and suppresses the browser menu. */
export function Card({ title, subtitle, children, onOpen, onMenu }: CardProps): ReactElement {
  const menu = (e: MouseEvent): void => {
    if (onMenu === undefined) return;
    e.preventDefault();
    onMenu(e.clientX, e.clientY);
  };
  return (
    <button type="button" className="p3-card" aria-label={title} onClick={onOpen} onContextMenu={menu}>
      <span className="p3-card-title">{title}</span>
      {subtitle === undefined ? null : <span className="p3-card-sub">{subtitle}</span>}
      {children}
    </button>
  );
}
